import { Popover, PopoverContent, PopoverTrigger, Portal } from '@chakra-ui/react';
import { IHeaderParams } from 'ag-grid-community';
import { useEffect, useRef, useState } from 'react';

import { useTableStore } from './store';

export const CustomHeader = (props: IHeaderParams) => {
  // const [ascSort, setAscSort] = useState('inactive');
  // const [descSort, setDescSort] = useState('inactive');
  // const [noSort, setNoSort] = useState('inactive');
  const { onUpdateCustomFieldName, isReadOnly } = useTableStore((s) => ({
    onUpdateCustomFieldName: s.onUpdateCustomFieldName,
    isReadOnly: s.isReadOnly,
  }));
  const refButton = useRef<HTMLDivElement>(null);
  const inputRef = useRef<HTMLInputElement>(null);
  const [displayName, setDisplayName] = useState<string>(props.displayName);
  const [isEditMode, setIsEditMode] = useState<boolean>(false);

  const onMenuClicked = () => {
    if (refButton.current) props.showColumnMenu(refButton.current);
  };

  useEffect(() => {
    if (props.displayName !== displayName) {
      setDisplayName(props.displayName);
    }
  }, [props.displayName]);

  // const onSortChanged = () => {
  //   setAscSort(props.column.isSortAscending() ? 'active' : 'inactive');
  //   setDescSort(props.column.isSortDescending() ? 'active' : 'inactive');
  //   setNoSort(
  //     !props.column.isSortAscending() && !props.column.isSortDescending() ? 'active' : 'inactive'
  //   );
  // };

  // const onSortRequested = (order, event) => {
  //   props.setSort(order, event.shiftKey);
  // };

  // useEffect(() => {
  //   props.column.addEventListener('sortChanged', onSortChanged);
  //   onSortChanged();
  // }, []);

  let menu;
  if (props.enableMenu) {
    menu = (
      <div ref={refButton} className="customHeaderMenuButton" onClick={() => onMenuClicked()}>
        <i className={`ag-icon ag-icon-menu`}></i>
      </div>
    );
  }

  // let sort;
  // if (props.enableSorting) {
  //   sort = (
  //     <div style={{ display: 'inline-block' }}>
  //       <div
  //         onClick={(event) => onSortRequested('asc', event)}
  //         onTouchEnd={(event) => onSortRequested('asc', event)}
  //         className={`customSortDownLabel ${ascSort}`}
  //       >
  //         <i className="fa fa-long-arrow-alt-down"></i>
  //       </div>
  //       <div
  //         onClick={(event) => onSortRequested('desc', event)}
  //         onTouchEnd={(event) => onSortRequested('desc', event)}
  //         className={`customSortUpLabel ${descSort}`}
  //       >
  //         <i className="fa fa-long-arrow-alt-up"></i>
  //       </div>
  //       <div
  //         onClick={(event) => onSortRequested('', event)}
  //         onTouchEnd={(event) => onSortRequested('', event)}
  //         className={`customSortRemoveLabel ${noSort}`}
  //       >
  //         <i className="fa fa-times"></i>
  //       </div>
  //     </div>
  //   );
  // }

  const handleOpenEditInput = () => {
    setIsEditMode(true);
    setTimeout(() => {
      if (inputRef.current) inputRef.current.select();
    }, 100);
  };

  return (
    <div className="flex justify-between w-full items-center">
      {/* <div className="customHeaderLabel">{props.displayName}</div> */}
      <Popover
        closeOnBlur
        onClose={() => setIsEditMode(false)}
        onOpen={handleOpenEditInput}
        isOpen={isEditMode}
        placement="top"
      >
        <PopoverTrigger>
          <button
            className="customHeaderLabel w-full  text-left cursor-text font-mediumbold"
            disabled={isReadOnly}
            onClick={() => setIsEditMode(true)}
          >
            {displayName}
          </button>
        </PopoverTrigger>
        <Portal>
          <PopoverContent>
            <input
              className="customHeaderLabel w-full bg-white border rounded-sm text-xs px-4 py-2"
              type="text"
              defaultValue={props.displayName}
              onChange={(e) => {
                setDisplayName(e.target.value);
              }}
              value={displayName}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  onUpdateCustomFieldName('', props.column.getId(), displayName);
                  setIsEditMode(false);
                }
              }}
              onBlur={() => {
                onUpdateCustomFieldName('', props.column.getId(), displayName);
                setIsEditMode(false);
              }}
              ref={inputRef}
            />
          </PopoverContent>
        </Portal>
      </Popover>
      {menu}
      {/* {sort} */}
    </div>
  );
};
